import React from 'react'
import { components } from 'react-select'

const TextSubtitleSingleValue = (props) => (
  <components.SingleValue {...props}>
    <div className='elo-react-select__option--column'>
      <div className='elo-react-select__option--title'>{props.data.label}</div>
      <div className='elo-react-select__option--subtitle'>{props.data.subtitle}</div>
    </div>
  </components.SingleValue>
)

export { TextSubtitleSingleValue }
